import React from 'react';
import { PropTypes as PT } from 'prop-types';
import Linkify from 'react-linkify';
import _reduce from 'lodash/reduce';
import { FormattedDate } from 'react-intl';
import { respectLineBreaks } from 'utils/string-utils';
import classes from './ChatMessageGroup.module.scss';

const ChatMessageGroup = (props) => {
  const {
    formattedTimestamp,
    isNewDate,
    isSenderSelf,
    messages = [{ senderName: null, formatedTS: null }],
    senderName,
    timestamp
  } = props.group;
  const messageBody =
    _reduce(
      messages,
      (messagesOnly, message) => {
        messagesOnly.push(message.body);
        return messagesOnly;
      },
      []
    ) || [];

  return (
    <div className={props.isInCall ? classes.isInCall : ''}>
      <div className={`${classes.groupHeader} ${isNewDate ? '' : classes.noHeaderText}`}>
        {isNewDate ? (
          <FormattedDate day="numeric" month="long" value={new Date(timestamp)} weekday="long" year="numeric" />
        ) : null}
      </div>

      <div className={`${classes.messageItem} ${isSenderSelf ? classes.myMessage : ''}`}>
        <div className={classes.messageLabel}>
          <span className={classes.from}>{senderName}</span>
          <span className={classes.timeStamp}>{formattedTimestamp}</span>
        </div>
        <div className={classes.messageContent}>
          <Linkify properties={{ target: '_blank' }}>{respectLineBreaks(messageBody.join('\n'))}</Linkify>
        </div>
      </div>
    </div>
  );
};

ChatMessageGroup.propTypes = {
  group: PT.object,
  isInCall: PT.bool
};

ChatMessageGroup.defaultProps = {
  group: {}
};

export default ChatMessageGroup;
